function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "git_svg__a",
  d: "M.037.07h56.894V57H.037z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(.87)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "git_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#git_svg__a"
})), React.createElement("path", {
  d: "M55.856 26L31 1.144a3.666 3.666 0 00-5.185 0l-5.161 5.163 6.547 6.547a4.353 4.353 0 015.514 5.55l6.31 6.311a4.354 4.354 0 014.508 1.035 4.362 4.362 0 010 6.17 4.362 4.362 0 01-7.12-4.745l-5.886-5.886v15.487a4.364 4.364 0 11-5.015 6.996 4.364 4.364 0 011.428-7.123V21.02a4.362 4.362 0 01-2.368-5.721l-6.455-6.456L1.073 25.885a3.67 3.67 0 000 5.186l24.858 24.856a3.668 3.668 0 005.185 0l24.74-24.74a3.667 3.667 0 000-5.187",
  fill: "#DE4C36",
  mask: "url(#git_svg__b)"
}));

var Git = function Git(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 58 57"
  }, props), _ref, _ref2);
};

export default Git;